import React from 'react';

type AddedPaddingProps = {
  children: React.ReactNode;
  padding: number;
};

const AddedPadding = ({ children, padding }: AddedPaddingProps) => {
  return <div style={{ padding }}>{children}</div>;
};

export default AddedPadding;
